// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"175":"314d6ec3","606":"e03c69ed","680":"8bdca97e","944":"f513dbe1"}[chunkId] + ".chunk.css";
};